import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import InvestmentBalanceCards from "../../Components/Buy/InvestmentBalanceCards";
import ActiveInvestmentsCarousel from "../../Components/Buy/ActiveInvestmentsCarousel";
import InvestmentListTabs from "../../Components/Buy/InvestmentListTabs";
import ActiveInvestmentDrawer from "../../Components/Buy/ActiveInvestmentDrawer";
import ActiveSalesInvestmentDrawer from "../../Components/Buy/ActiveSalesInvestmentDrawer";
import getServices from "../../Services/get-service";
import postService from "../../Services/post-service";
import Constant from "../../Constant";
import { toast } from "react-toastify";

import PropertyDetailsDrawer from "../../Components/Buy/PropertyDetailsDrawer";
import UnitSelectorModal from "../../Components/Buy/UnitSelectorModal";
import PaymentMethodModal from "../../Components/Buy/PaymentMethodModal";
import PurchaseSummaryModal from "../../Components/Buy/PurchaseSummaryModal";
import PinModal from "../../Components/Buy/PinModal";
import PurchaseSuccessModal from "../../Components/Buy/PurchaseSuccessModal";

function Buy() {
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [purchaseData, setPurchaseData] = useState(null); // { units, totalValue, formattedTotal }

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isActiveDrawerOpen, setIsActiveDrawerOpen] = useState(false);
  const [isUnitModalOpen, setIsUnitModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isSummaryModalOpen, setIsSummaryModalOpen] = useState(false);
  const [isPinModalOpen, setIsPinModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isBooking, setIsBooking] = useState(false);

  const handlePropertyClick = (property) => {
    setSelectedProperty(property);
    setIsDrawerOpen(true);
  };
  const handleActivePropertyClick = (property) => {
    setSelectedProperty(property);
    setIsActiveDrawerOpen(true);
  };

  const handleBuyUnitsClick = () => {
    setIsDrawerOpen(false);
    setIsUnitModalOpen(true);
  };

  const handleUnitContinue = (data) => {
    setPurchaseData(data);
    setIsUnitModalOpen(false);
    setIsPaymentModalOpen(true);
  };

  const handlePaymentReview = () => {
    setIsPaymentModalOpen(false);
    setIsSummaryModalOpen(true);
  };

  const handleSummaryConfirm = () => {
    setIsSummaryModalOpen(false);
    setIsPinModalOpen(true);
  };

  const handlePinConfirm = async (pinValue) => {
    setIsBooking(true);
    try {
      const response = await postService.buyProject(selectedProperty.id, purchaseData.units, pinValue);
      if (response.data.statusCode === 200) {
        setIsPinModalOpen(false);
        setIsSuccessModalOpen(true);
      } else {
        toast.error(response.data.description);
      }
    } catch (error) {
      toast.error(error?.response?.data?.description || "An error occurred");
    } finally {
      setIsBooking(false);
    }
  };

  const closeAll = () => {
    setIsDrawerOpen(false);
    setIsUnitModalOpen(false);
    setIsPaymentModalOpen(false);
    setIsSummaryModalOpen(false);
    setIsPinModalOpen(false);
    setIsSuccessModalOpen(false);
    setIsActiveDrawerOpen(false);
  };

  const handleBuyMoreUnitsClick = () => {
    setIsActiveDrawerOpen(false);
    setIsUnitModalOpen(true);
  };

  return (
    <div>
      <Outlet />
      <InvestmentBalanceCards />
      <ActiveInvestmentsCarousel onPropertyClick={handleActivePropertyClick} />
      <InvestmentListTabs onPropertyClick={handlePropertyClick} />

      <PropertyDetailsDrawer 
        open={isDrawerOpen} 
        handleClose={() => setIsDrawerOpen(false)} 
        property={selectedProperty} 
        onBuyClick={handleBuyUnitsClick}
      />
      
      {selectedProperty?.type?.toString().toUpperCase().includes("SALE") ? (
        <ActiveSalesInvestmentDrawer
          open={isActiveDrawerOpen}
          handleClose={() => setIsActiveDrawerOpen(false)}
          property={selectedProperty}
          onBuyClick={handleBuyMoreUnitsClick}
        />
      ) : (
        <ActiveInvestmentDrawer
          open={isActiveDrawerOpen}
          handleClose={() => setIsActiveDrawerOpen(false)}
          property={selectedProperty}
          onBuyClick={handleBuyMoreUnitsClick}
        />
      )}
      <UnitSelectorModal 
        open={isUnitModalOpen} 
        handleClose={closeAll} 
        property={selectedProperty}
        onContinue={handleUnitContinue}
      />
      <PaymentMethodModal 
        open={isPaymentModalOpen} 
        handleClose={closeAll} 
        handleBack={() => { setIsPaymentModalOpen(false); setIsUnitModalOpen(true); }}
        onReviewOrder={handlePaymentReview}
      />
      <PurchaseSummaryModal 
        open={isSummaryModalOpen} 
        handleClose={closeAll} 
        handleBack={() => { setIsSummaryModalOpen(false); setIsPaymentModalOpen(true); }}
        property={selectedProperty}
        purchaseData={purchaseData}
        onConfirm={handleSummaryConfirm}
      />
      <PinModal 
        open={isPinModalOpen} 
        handleClose={closeAll} 
        handleBack={() => { setIsPinModalOpen(false); setIsSummaryModalOpen(true); }}
        onConfirm={handlePinConfirm}
        isLoading={isBooking}
      />
      <PurchaseSuccessModal 
        open={isSuccessModalOpen} 
        handleClose={closeAll} 
        property={selectedProperty}
        purchaseData={purchaseData}
      />
    </div>
  );
}

export default Buy;
